import useHasPermission from '../../helpers/hooks/useHasPermission';
var Permission = function Permission(_ref) {
  var _ref$permission = _ref.permission,
    permission = _ref$permission === void 0 ? null : _ref$permission,
    children = _ref.children;
  var hasPermission = useHasPermission(permission);
  if (!hasPermission) return null;
  return /*#__PURE__*/React.createElement(React.Fragment, null, children);
};
export default Permission;